import { Capacitor } from '@capacitor/core';

/** Production website, or the iOS / Android app. Beta and local web stay off. */
export function isProductAnalyticsEnabled(): boolean {
  const platform = Capacitor.getPlatform();
  const nativeApp = platform === 'ios' || platform === 'android';
  const productionWeb = process.env.REACT_APP_DEPLOY_ENV === 'production';
  return nativeApp || productionWeb;
}
